/**
 * Exports a collection of easing curves, which can easily be used to perform
 * easing on a progress value ranging from 0 to 1.
 */

/**
 * Plain implementation of easeInQuad
 */
export function easeInQuad(t: number): number {
    return t * t;
}

/**
 * Plain implementation of easeOutQuad
 */
export function easeOutQuad(t: number): number {
    return t * (2 - t);
}

/**
 * Plain implementation of easeInOutQuad
 */
export function easeInOutQuad(t: number): number {
    return t < 0.5
        ? t * t * 2
        : t * (4 - t * 2) - 1;
}

/**
 * Plain implementation of easeInCubic
 */
export function easeInCubic(t: number): number {
    return t * t * t;
}

/**
 * Plain implementation of easeOutCubic
 */
export function easeOutCubic(t: number): number {
    // tslint:disable-next-line no-parameter-reassignment
    return (--t) * t * t + 1;
}

/**
 * Plain implementation of easeInOutCubic
 */
export function easeInOutCubic(t: number): number {
    return t < 0.5
        ? t * t * t * 4
        : (t - 1) * (t * 2 - 2) * (t * 2 - 2) + 1;
}

/**
 * Plain implementation of easeInQuart
 */
export function easeInQuart(t: number): number {
    return t * t * t * t;
}

/**
 * Plain implementation of easeOutQuart
 */
export function easeOutQuart(t: number): number {
    // tslint:disable-next-line no-parameter-reassignment
    return 1 - (--t) * t * t * t;
}

/**
 * Plain implementation of easeInOutQuart
 */
export function easeInOutQuart(t: number): number {
    return t < 0.5
        ? t * t * t * t * 8
        : 1 - (--t) * t * t * t * 8; // tslint:disable-line no-parameter-reassignment
}

/**
 * Plain implementation of easeInQuint
 */
export function easeInQuint(t: number): number {
    return t * t * t * t * t;
}

/**
 * Plain implementation of easeOutQuint
 */
export function easeOutQuint(t: number): number {
    // tslint:disable-next-line no-parameter-reassignment
    return (--t) * t * t * t * t + 1;
}

/**
 * Plain implementation of easeInOutQuint
 */
export function easeInOutQuint(t: number): number {
    return t < 0.5
        ? t * t * t * t * t * 16
        : (--t) * t * t * t * t * 16 + 1; // tslint:disable-line no-parameter-reassignment
}
